export class SecurityUserDto {
    id = 0;
    firstName = '';
    lastName = '';
    email = '';
    salesId = '';
    employeeId = '';
    roleIds: number[] = [];
    fullName = '';
}
